import { render, staticRenderFns } from "./delivery-address-hist-button.vue?vue&type=template&id=458129e2&lang=pug&"
import script from "./delivery-address-hist-button.vue?vue&type=script&lang=ts&"
export * from "./delivery-address-hist-button.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports